import React, { forwardRef, useEffect, useState, useRef } from "react";
import { Form, Row, Col, Input, Select, Radio, InputNumber } from "antd";
import axios from "axios";

function SqFormDetail(props, ref) {
  const formRef = useRef();
  const { tokens, models, userInfo, type, selectedRow } = props;
  const [modelName, setModelName] = useState("");
  const [tokenName, setTokenName] = useState("");
  const layout = {
    labelCol: {
      span: 8,
      style: { textAlign: "right", whiteSpace: "normal" },
    },
    wrapperCol: {
      span: 16,
    },
  };

  useEffect(() => {
    if (type === "edit") {
      // axios.
    }
  }, []);

  if (ref) {
    ref.current = {
      getValue: () => {
        return {
          ...formRef.current?.getFieldsValue(),
          modelName: modelName,
          tokenName: tokenName,
        };
      },
      verify: async () => {
        try {
          return await formRef.current.validateFields();
        } catch {
          return Promise.reject();
        }
      },
    };
  }

  return (
    <>
      <Form
        ref={formRef}
        style={{
          padding: "25px 0",
        }}
        initialValues={
          type === "add"
            ? {
                userCode: userInfo?.code,
                userName: userInfo?.name,
                orgName: userInfo?.orgs?.[0]?.name,
                phone: userInfo?.phone,
                email: userInfo?.email,
              }
            : selectedRow
        }
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item {...layout} label="工号" name="userCode">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label="姓名" name="userName">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label="单位" name="orgName">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label="联系方式" name="phone">
              <Input disabled={type === "add" ? false : true} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              labelCol={{
                span: 4,
              }}
              label="邮箱"
              name="email"
            >
              <Input disabled={type === "add" ? false : true} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "请选择模型",
                },
              ]}
              {...layout}
              label="模型选择"
              name="modelId"
            >
              <Select
                options={models}
                onChange={(val, row) => {
                  setModelName(row?.label);
                }}
                disabled={type === "add" ? false : true}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "请选择令牌",
                },
              ]}
              {...layout}
              label="关联令牌"
              name="tokenId"
            >
              <Select
                options={tokens}
                onChange={(val, row) => {
                  setTokenName(row?.label);
                }}
                disabled={type === "add" ? false : true}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "请填写令牌配额",
                },
              ]}
              {...layout}
              label="令牌配额"
              name="remainQuota"
            >
              <InputNumber
                min={0}
                precision={0}
                disabled={type === "add" ? false : true}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              labelCol={{
                span: 4,
              }}
              label="申请理由"
              name="reason"
            >
              <Input.TextArea
                autoSize={{
                  minRows: 3,
                  maxRows: 6,
                }}
                disabled={type === "add" ? false : true}
              />
            </Form.Item>
          </Col>
          {type === "check" || type ==="see" ? (
            <>
              <Col span={24}>
                <Form.Item
                  labelCol={{
                    span: 4,
                  }}
                  label="审核状态"
                  name="status"
                  rules={[
                    {
                      required: true,
                      message: "请选择审核状态",
                    },
                  ]}
                >
                  <Radio.Group
                    options={[
                      {
                        label: "通过",
                        value: 2,
                      },
                      {
                        label: "驳回",
                        value: 3,
                      },
                    ]}
                     disabled={type === "see" ? true : false}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  labelCol={{
                    span: 4,
                  }}
                  label="审核意见"
                  name="auditOpinion"
                >
                  <Input.TextArea
                    autoSize={{
                      minRows: 3,
                      maxRows: 6,
                    }}
                    disabled={type === "see" ? true : false}
                  />
                </Form.Item>
              </Col>
            </>
          ) : undefined}
        </Row>
      </Form>
    </>
  );
}

export default forwardRef(SqFormDetail);
